import { createIcon } from '../utils';

export const EcgPlaceholderIcon = createIcon(
  ({ ref, className, width = 100, height = 60, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 100 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ECG not available"
      {...rest}
    >
      <g clipPath="url(#clip0_6722_187959)">
        <path
          d="M0 4C0 1.79086 1.79086 0 4 0H96C98.2091 0 100 1.79086 100 4V56C100 58.2091 98.2091 60 96 60H4C1.79086 60 0 58.2091 0 56V4Z"
          fill="white"
        />
        <path d="M10 0V108" stroke="#F3F4F6" />
        <path d="M20 0V108" stroke="#F3F4F6" />
        <path d="M30 0V108" stroke="#F3F4F6" />
        <path d="M40 0V108" stroke="#F3F4F6" />
        <path d="M50 0V108" stroke="#F3F4F6" />
        <path d="M60 0V108" stroke="#F3F4F6" />
        <path d="M70 0V108" stroke="#F3F4F6" />
        <path d="M80 0V108" stroke="#F3F4F6" />
        <path d="M90 0V108" stroke="#F3F4F6" />
        <path d="M100 0V108" stroke="#F3F4F6" />
        <path d="M0 10H100" stroke="#F3F4F6" />
        <path d="M0 20H100" stroke="#F3F4F6" />
        <path d="M0 30H100" stroke="#F3F4F6" />
        <path d="M0 40H100" stroke="#F3F4F6" />
        <path d="M0 50H100" stroke="#F3F4F6" />
        <path d="M0 60H100" stroke="#F3F4F6" />
        <path
          d="M17 41.1111H34.6745C35.0487 41.1111 35.3916 41.32 35.5632 41.6525L37.2905 45L39.5203 10L41.2377 41.3794C41.2818 42.1857 41.4151 42.9846 41.6352 43.7616L42.2081 45.7837C42.7556 47.7161 44.2575 49.2318 46.1849 49.7967C46.576 49.9114 46.9893 49.7051 47.1329 49.3236L49.2479 43.7025C49.8345 42.1434 51.3259 41.1111 52.9917 41.1111H61.1179C61.5709 41.1111 62.0105 40.9573 62.3647 40.6749L64.2104 39.2033C66.0634 37.7259 68.699 37.7522 70.522 39.2663L72.1876 40.6497C72.5467 40.9479 72.9987 41.1111 73.4655 41.1111H83"
          stroke="#D1D5DB"
          strokeWidth={1.6}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-48 41.1111H-30.3255C-29.9513 41.1111 -29.6084 41.32 -29.4368 41.6525L-27.7095 45L-25.4797 10L-23.7623 41.3794C-23.7182 42.1857 -23.5849 42.9846 -23.3648 43.7616L-22.7919 45.7837C-22.2444 47.7161 -20.7425 49.2318 -18.8151 49.7967C-18.424 49.9114 -18.0107 49.7051 -17.8671 49.3236L-15.7521 43.7025C-15.1655 42.1434 -13.6741 41.1111 -12.0083 41.1111H-3.88215C-3.42913 41.1111 -2.98954 40.9573 -2.63533 40.6749L-0.78957 39.2033C1.06339 37.7259 3.69896 37.7522 5.52203 39.2663L7.18765 40.6497C7.5467 40.9479 7.99873 41.1111 8.46547 41.1111H18"
          stroke="#D1D5DB"
          strokeWidth={1.6}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84 41.1111H101.675C102.049 41.1111 102.392 41.32 102.563 41.6525L104.291 45L106.52 10L108.238 41.3794C108.282 42.1857 108.415 42.9846 108.635 43.7616L109.208 45.7837C109.756 47.7161 111.258 49.2318 113.185 49.7967C113.576 49.9114 113.989 49.7051 114.133 49.3236L116.248 43.7025C116.835 42.1434 118.326 41.1111 119.992 41.1111H128.118C128.571 41.1111 129.01 40.9573 129.365 40.6749L131.21 39.2033C133.063 37.7259 135.699 37.7522 137.522 39.2663L139.188 40.6497C139.547 40.9479 139.999 41.1111 140.465 41.1111H150"
          stroke="#D1D5DB"
          strokeWidth={1.6}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6722_187959">
          <path
            d="M0 4C0 1.79086 1.79086 0 4 0H96C98.2091 0 100 1.79086 100 4V56C100 58.2091 98.2091 60 96 60H4C1.79086 60 0 58.2091 0 56V4Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  { displayName: 'EcgPlaceholderIcon' },
);
